module.exports = __webpack_public_path__ + "img/versoapp.68f23125.png";